import pick from 'lodash/pick';

import {ApiResource} from 'common/util/model-resource/api-resource';
import {PropertyDefinition} from 'iron/apps/lexicon/src/models';
import {Model} from 'common/util/model-resource/model-resource';
import {CustomProperty} from 'common/types/reports/query';

import {bulkDelete, bulkUpdate, customPropertyClient, update} from '../queries/app-api/custom-properties-client';

export class CustomPropertiesResource extends ApiResource<CustomProperty> {
  apiClient = customPropertyClient;

  async bulkDelete(customPropertyIds: number[]): ReturnType<typeof bulkDelete> {
    return bulkDelete(customPropertyIds);

    // TODO - updating the model is not needed for now since it's done manually where bulkDelete is used for now
    // customPropertyIds.forEach((customPropertyId) => {
    //   this.delete(customPropertyId);
    // });
  }

  async bulkPatch(customPropertyUpdates: Record<number, Partial<CustomProperty>>): ReturnType<typeof bulkUpdate> {
    const apiPayload = Object.entries(customPropertyUpdates).map(([customPropertyId, customPropUpdate]) => {
      return this.buildUpdatePayload(parseInt(customPropertyId), customPropUpdate);
    });
    return bulkUpdate(apiPayload);

    // TODO - updating the model is not needed for now since it's done manually where bulkDelete is used for now
    // this.update(customPropertyUpdates);
  }

  buildUpdatePayload(customPropertyId: number, customPropertyUpdate: Partial<CustomProperty>) {
    const customProp = this.getOne(customPropertyId).value;
    return {
      ...customProp,
      ...customPropertyUpdate,
    };
  }

  async patch(customEventId: number, customPropertyUpdate: Partial<CustomProperty>): Promise<Model<CustomProperty>> {
    const updateResponse = await update(customEventId, this.buildUpdatePayload(customEventId, customPropertyUpdate));
    this.update({[customEventId]: updateResponse});
    return this.getOne(customEventId);
  }

  async patchFromEventDefUpdate(propertyDef: PropertyDefinition, propertyDefUpdate: Partial<PropertyDefinition>) {
    if (!propertyDef.customPropertyId) {
      return this.notFoundModel();
    }
    const customProperty = this.getOne(propertyDef.customPropertyId!.toString());
    // If there isn't actually a CustomProperty associated with this PropertyDefinition, then there's nothing to update.
    if (!customProperty.value) {
      return this.notFoundModel();
    }
    const customPropertyUpdate = {
      // set 'name' to be the display name of the PropDef, if that update is supplied.
      ...(propertyDefUpdate.displayName ? {name: propertyDefUpdate.displayName} : {}),
      // copy the known user-editable attributes
      ...pick(propertyDefUpdate, [`description`, `exampleValue`]),
    };
    return this.patch(propertyDef.customPropertyId!, customPropertyUpdate);
  }
}
